import { UseQueryResult } from 'react-query';
import { useMyQuery, QueryInfos, Options } from '../helpers';
import { EmptyInput } from '../../apiTypes';
import { typePromotions } from './types';

const promotionsQuery = (variables: EmptyInput): QueryInfos => {
    return {
        name: 'promotions',
        path: '/promotions',
        type: typePromotions.GET_PROMOTIONS,
        params: {
            ...variables,
        },
    };
};

export function useGetPromotions<T>(options?: Options<EmptyInput>): UseQueryResult<T, Error> {
    return useMyQuery<T, EmptyInput>(promotionsQuery, options);
}
